import * as CSS from 'csstype';

export interface FontWeights extends Pick<CSS.Properties, 'fontWeight'> {
  /** @returns `300` */
  light: number;
  /** @returns `400` */
  regular: number;
  /** @returns `500` */
  strong: number;
  /** @returns `600` */
  slightlyStrong: number;
  /** @returns `700` */
  stronger: number;
  /** @returns `800` */
  extraStrong: number;
  /** @returns `800` */
  heading: number;
  /** @returns `800` */
  subheading: number;
  /** @returns `900` */
  strongest: number;
}

export interface LineHeights extends Pick<CSS.Properties, 'lineHeight'> {
  /** @returns `1` */
  default: number;
  /** @returns `1.1` */
  heading: number;
  /** @returns `1.1` */
  subheading: number;
  /** @returns `1.1` */
  interactive: number;
  /** @returns `1.2` */
  label: number;
  /** @returns `1.35` */
  paragraph: number;
  /** @returns `1.5` */
  body: number;
  /** @returns `1.75` */
  subNavLink: number;
}

export interface LetterSpacing extends Pick<CSS.Properties, 'letterSpacing'> {
  /** @returns `normal` */
  body: string;
  /** @returns `normal` */
  heading: string;
}

const fontWeights: FontWeights = {
  light: 300,
  regular: 400,
  strong: 500,
  slightlyStrong: 600,
  stronger: 700,
  extraStrong: 800,
  heading: 800,
  subheading: 800,
  strongest: 900,
};

const lineHeights: LineHeights = {
  default: 1,
  heading: 1.1,
  subheading: 1.1,
  interactive: 1.1,
  label: 1.2,
  paragraph: 1.35,
  body: 1.5,
  subNavLink: 1.75,
};

const letterSpacings: LetterSpacing = {
  body: 'normal',
  heading: 'normal',
};

export interface Fonts {
  fonts: {
    /** @return 'Graphik, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif' */
    body: string;
    /** @return 'Graphik, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif' */
    heading: string;
    /** @return 'monospace' */
    monospace: string;
    /** @return 'Graphik' */
    graphik: string;
  };
  fontWeights: FontWeights;
  lineHeights: LineHeights;
  letterSpacings: LetterSpacing;
}

const fonts: Fonts = {
  fonts: {
    body: 'Graphik, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif',
    heading: 'Graphik, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif',
    monospace: 'monospace',
    graphik: 'Graphik',
  },
  fontWeights,
  lineHeights,
  letterSpacings,
};

export default fonts;
